import { useState } from 'react';
import { useLanguage } from '../../i18n/LanguageContext';
import { useDealer } from '../../context/DealerContext';
import { dealerApi } from '../../services/dealerApi';
import { dealerErrorMessage, fmt, formatDate } from '../../utils/dealer';

/**
 * Spec 085 (Flow A, G5/Q5-A, BR-4) — the first-login click-through: the dealer user accepts the dealer
 * terms once (recorded with user + timestamp by `POST /api/dealers/me/agreement/accept`) before any
 * other dealer screen opens.
 */
export default function DealerAgreementGate() {
  const { t, lang } = useLanguage();
  const { token, me, reload } = useDealer();
  const [checked, setChecked] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const accept = async () => {
    if (!token || !checked) return;
    setSaving(true);
    setError(null);
    try {
      await dealerApi.acceptAgreement(token);
      await reload();
    } catch (err) {
      setError(dealerErrorMessage(err, t));
    } finally {
      setSaving(false);
    }
  };

  const tradeName = me?.dealer.tradeName ?? '';
  return (
    <div className="dealer-page dealer-agreement">
      <div className="dealer-card">
        <h2>{t('dealer.agreement.title')}</h2>
        <p>{fmt(t('dealer.agreement.intro'), { dealer: tradeName })}</p>
        <ul className="dealer-agreement__points">
          <li>{t('dealer.agreement.point.credit')}</li>
          <li>{t('dealer.agreement.point.payment')}</li>
          <li>{t('dealer.agreement.point.expiry')}</li>
          <li>{t('dealer.agreement.point.buyers')}</li>
        </ul>
        {me?.dealer.agreementSignedAt && (
          <p className="dealer-muted">
            {fmt(t('dealer.agreement.signedOn'), { date: formatDate(me.dealer.agreementSignedAt, lang) })}
          </p>
        )}
        {error && <div className="error-message">{error}</div>}
        <label className="checkbox-label dealer-agreement__check">
          <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} />
          <span>{fmt(t('dealer.agreement.checkbox'), { dealer: tradeName })}</span>
        </label>
        <button type="button" className="btn btn-primary" disabled={!checked || saving} onClick={accept}>
          {saving ? t('dealer.common.saving') : t('dealer.agreement.accept')}
        </button>
      </div>
    </div>
  );
}
